import { CloseCircleOutlined, ExclamationCircleOutlined, ExperimentOutlined, InfoCircleOutlined, InfoOutlined, PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons"
import { Badge, Button, Divider, Modal, Select, Space, message } from "antd"
import styles from './styles.module.less'
import ConfigSimulationModal from "./ConfigSimulationModal"
import { useContext, useState } from "react"
import classNames from "classnames"
import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { SimulationWorkbook } from "./Workbook/SimulationWorkbook"
import { SimulationModal, checkTopology } from "@/services/project/simulation.service"
import { IconButton } from "@/components/IconButton/IconButton"
import { isEmpty } from "lodash-es"
import { loadSimThunk, unloadSimThunk } from "@/store/flowsheet/actions"
import { useDispatch, useSelector } from "react-redux"
import { RunState, getFlowSimulationSelector, getStatus, getTopologyState, setFlowSimulation, setSimStatus, setTopologyState } from "@/store/flowsheet/flowsheet.slice"
import { getProjectCases, getProjectPropertySets, getProjectSimulations } from "@/store/project/selector"
import { useFSId } from "@/components/FlowSheetEditor/hooks/useFSId"
import { getProjectSimulationsThunk } from "@/store/project/actions"
import { SimulationStatus } from "./SimulationStatus"
import { ReactState } from "@/components/FlowSheetEditor/hooks/useReactState"
import { PanelType } from "../../RightPanel/types"
const { confirm } = Modal;

const tipMessage = 'Inconsistent flowsheet and simulation topology. Running the simulation will clear the existing simulation and create a new simulation'

export function Simulation({panelState}: {panelState: ReactState}) {
  const dispatch = useDispatch()
  const fsId = useFSId();
  const cases = useSelector(getProjectCases)
  const simulations = useSelector(getProjectSimulations)
  const propertySets = useSelector(getProjectPropertySets)
  const simulation = useSelector(getFlowSimulationSelector)
  const status = useSelector(getStatus);
  const {runWithSimlation, handleTopology} = useContext(FlowsheetContext)
  
  const [selected, setSelected] = useState<number | null>(simulation?.opcase.id || null)
  const simData = useSelector(getTopologyState)
  const items = cases.map(item => {
    const valid = simulations.some(sim => sim.opcase.id === item.id)
    return {value: item.id, label: <div>
      <ExperimentOutlined className={classNames(styles.simIcon, !valid && styles.error)} /><span className="ml-1">{`${item.number} - ${item.name}`}</span></div>}
  })
  const selectedValid = simulations.some(item => item.opcase.id === selected)
  const selectedSim = simulations.find(item => item.opcase.id === selected)
  const runSim = async () => {
    if (selectedSim) {
      await runWithSimlation(selectedSim)
      dispatch(setSimStatus(RunState.Run))
    }
  }

  const stop = () => {
    dispatch(setSimStatus(RunState.Stop))
  }

  const unloadSim = async () => {
    const res =await dispatch(unloadSimThunk(simulation!.id) as any).unwrap();
  }

  const loadSim = async (sim: SimulationModal) => {
    await dispatch(loadSimThunk(sim.id) as any).unwrap();
  }

  const onSelect = async (caseId: number) => {
    setSelected(caseId)
    const sim = simulations.find(item => item.opcase.id === caseId)
    dispatch(setFlowSimulation(sim!))
    dispatch(setSimStatus(RunState.Init))
    if (sim) {
      await loadSim(sim)
      const res = await handleTopology(sim, (simData, params) => {
        return checkTopology(simData, params)
      })
      if (!isEmpty(res)) {
        message.warning(`Some data not sync to simulation [${sim.opcase.name}]`, 3)
      } else {
        dispatch(setSimStatus(RunState.Run))
      }
    } else {
      dispatch(setTopologyState(null))
    }
  }

  const runBtnDistabled = !selectedValid || RunState.Run === status
  const simLoaded = simData && simData.status !== 1000

  const getRunButton = () => {
    if (!runBtnDistabled && simLoaded) {
      return <RunButton loaded={simLoaded} onClick={() => {
        confirm({
          content: <div>{tipMessage}</div>,
          onOk() {
            runSim()
          },
        })
      }}/>
    }

    return <IconButton disabled={runBtnDistabled} onClick={runSim}>
      <RunButton loaded={!!simLoaded} />
    </IconButton>
  }

  const openSimLogPanel = () => {
    panelState.setValue(PanelType.SimLogs)
  }

  return <Space className="ml-4">
    <SimulationWorkbook simulation={selectedSim}/>
    <Select
      style={{ width: 160 }}
      value={selected}
      placeholder="Select a Simulation"
      onChange={onSelect}
      dropdownRender={(menu) => (
        <>
          {menu}
          <div className={styles.ConfigSimulation}>
            <Button type="text" onClick={() => {
              ConfigSimulationModal.show({
                cases,
                simulations,
                propertySets,
                fsId,
                onSuccess: () => {
                  dispatch(getProjectSimulationsThunk(fsId))
                }
              })
            }}>Config Simulations</Button>
          </div>
        </>
      )}
      options={items}
    />
    <Space>
      {getRunButton()}
      
      <IconButton onClick={stop} disabled={status !== RunState.Run}>
        <PauseCircleOutlined className={classNames(styles.simBtn, styles.pauseBtn)} />
      </IconButton>

      <IconButton onClick={unloadSim} disabled={status !== RunState.Run}><i
        className={classNames('iconfont icon-stop-circle', styles.simBtn, styles.simStopBtn)}/></IconButton>

      {status === RunState.Run && <>
        <Divider type="vertical" />
        <SimulationStatus onClick={openSimLogPanel} />
      </>}
    </Space>

    
  </Space>
}

interface RunButtonProps {
  loaded: boolean
  onClick?: () => void
}
const RunButton = (props: RunButtonProps) => {
  const {loaded, onClick} = props


  if (!loaded) {
    return <PlayCircleOutlined title='Run' style={{color: 'green'}} className={classNames(styles.simBtn, 'antd-icon')} />
  }

  return <span style={{position: 'relative'}} onClick={onClick}>
    <PlayCircleOutlined title={tipMessage} style={{color: 'red'}} className={classNames(styles.simBtn, 'antd-icon')} />
  </span>
}